<div class="d-sm-block d-none">
  <mdb-badge
    [pill]="true"
    [info]="LIST_BASKET_ORDER_STATUS.ACCEPTED.code === basketOrder?.status?.code"
    [success]="
      LIST_BASKET_ORDER_STATUS.PAID.code === basketOrder?.status?.code ||
      (LIST_BASKET_ORDER_STATUS.BILLED.code === basketOrder?.status?.code && LIST_PAYMENT_METHOD.INIT_TRANSFERT_DEFERRED.code !== basketOrder?.paymentMethod?.code)
    "
    [danger]="
      LIST_BASKET_ORDER_STATUS.CANCELED.code === basketOrder?.status?.code ||
      LIST_BASKET_ORDER_STATUS.OFFLINE.code === basketOrder?.status?.code ||
      LIST_BASKET_ORDER_STATUS.ISSUED.code === basketOrder?.status?.code ||
      LIST_BASKET_ORDER_STATUS.LATE.code === basketOrder?.status?.code
    "
    [warning]="hasToBePaid()"
  >
    {{ (hasToBePaid() ? 'INVOICE_STATUS.TO_BE_PAID' : basketOrder?.status?.translationKey) | translate }}
    <mdb-icon
      *ngIf="LIST_BASKET_ORDER_STATUS.LATE.code === basketOrder?.status?.code && basketOrder.nbRelaunch"
      fas
      icon="info-circle"
      class="p-1 p-sm-2 pl-sm-1"
      [mdbTooltip]="getLateTooltipMessage()"
    ></mdb-icon>
  </mdb-badge>
</div>
<span class="d-block d-sm-none emojis" [mdbTooltip]="(hasToBePaid() ? 'INVOICE_STATUS.TO_BE_PAID' : basketOrder?.status?.translationKey) | translate"
  >{{ hasToBePaid() ? '💸' : basketOrder?.status?.emoji }}
</span>
